// Hook odpowiedzialny za pobranie szczgółów reklamacji / zwrotu

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError, IStatus } from 'api/types';

// typ zwracanych danych
export interface IResponse {
  id?: number;
  order_position_id?: number;
  return_complain_type_id?: number;
  return_complain_reason_id?: number;
  status?: number;
  description?: string;
  user_notes?: string;
  custom_symbol?: string;
  request_date?: string;
  client_id?: number;
  user_id?: number;
  order_id?: number;
  id_external?: string;
  store_id?: number;
  type_name?: string;
  reason_name?: string;
  status_name?: string;
  status_data?: IStatus;
  order_symbol?: string;
  product_name?: string;
  product_code?: string;
  is_editable?: boolean
}

const getReturnComplaint = (id: string): Promise<IResponse> => axios.get(`/return-complain/${id}`);

export const useGetReturnComplaint = (id: string, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['return-complain', id], () => getReturnComplaint(id), options);
